import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import dosa from '../Assets/products/d.png';
import dosa2 from '../Assets/products/d2.png';
import idiyapam from '../Assets/products/i.png';
import idiyapam2 from '../Assets/products/i2.png';
import chappathi from '../Assets/products/c.png';
import chappathi2 from '../Assets/products/c2.png';

const Ingredients = () => {
  const ing_details = [
    {
      name: 'Dosa',
      heading: 'Aryaa Idli / Dosa Wet Mix',
      subheading: "The best idlies and dosas are made with the freshest ingredients. And that's what we use with absolutely no preservatives.",
      subheading2: "Just like all iD products, the idli and dosa batter is made to bring you only fresh food and a dose of health.",
      ing_array: ["100% natural ingredients", "Freshly prepared", "Gluten-free"],
      nut_array: ["100% natural ingredients", "Freshly prepared", "Gluten-free"],
      img: dosa,
      img2: dosa2
    },
    {
      name: 'Idiyapam',
      heading: 'Aryaa Idiyapam Wet Mix',
      subheading: "Enjoy soft and delicious idiyappam with our special wet mix made from high-quality ingredients.",
      subheading2: "Easy to prepare and perfect for a healthy meal.",
      ing_array: ["Rice flour", "Water", "Salt"],
      nut_array: ["Low in fat", "High in carbohydrates", "No preservatives"],
      img: idiyapam,
      img2: idiyapam2
    },
    {
      name: 'Chappathi',
      heading: 'Aryaa Chappathi Wet Mix',
      subheading: "Make soft and fluffy chappathis with our carefully prepared wet mix, free from preservatives.",
      subheading2: "Convenient and nutritious, ideal for your daily meals.",
      ing_array: ["Whole wheat flour", "Water", "Salt", "Oil"],
      nut_array: ["High in fiber", "Rich in vitamins", "No preservatives"],
      img: chappathi,
      img2: chappathi2
    }
  ];

  return ing_details;
};

const ProductSlider1 = () => {
  const ing_details = Ingredients();
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? ing_details.length - 1 : prevIndex - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === ing_details.length - 1 ? 0 : prevIndex + 1));
  };

  const currentIngredient = ing_details[currentIndex];

  return (
    <>
      <section className='min-h-[100vh] flex items-center bg-yellow-50 bg-cover bg-no-repeat bg-center'>
        <div className='container mx-auto relative flex flex-col pb-4 lg:flex-row lg:items-center lg:gap-y-0 lg:gap-x-5'>
          <button
            className='absolute sm:left-[-13%] md:left-[0] top-1/2 transform -translate-y-1/2 px-4 py-2 text-2xl bg-gray-800 text-white rounded-full'
            onClick={prevSlide}
          >
            ❮
          </button>
          <div className='flex flex-1 justify-center items-center'>
            <AnimatePresence mode="wait">
              <motion.img
                key={currentIngredient.img}
                src={currentIngredient.img}
                className="lg:feedback2 sm:max-w-[200px] sm:py-10 lg:py-0 md:max-w-[350px] ripple-effect"
                alt={currentIngredient.name}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                loading='lazy'
              />
            </AnimatePresence>
          </div>
          <div className='flex flex-1 flex-col px-5 text-left '>
            <h2 className='font-primary sm:text-4xl md:text-7xl pb-7 '><span className='text-accent'>Our</span> Ingredients</h2>
            <h3 className='font-secondary text-2xl pb-5'>{currentIngredient.heading}</h3>
            <p className='pb-5 text-xl'>{currentIngredient.subheading}</p>
            <ul className='text-md'>
              {currentIngredient.ing_array.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
          <button
            className='absolute top-1/2 sm:right-[-13%] md:right-[0] transform -translate-y-1/2 px-4 py-2 text-2xl bg-gray-800 text-white rounded-full'
            onClick={nextSlide}
          >
            ❯
          </button>
        </div>
      </section>

      <section className='min-h-[100vh] flex items-center bg-aboutc bg-cover bg-no-repeat bg-center'>
        <div className='container mx-auto relative flex flex-col pb-4 lg:flex-row lg:items-center lg:gap-y-0 lg:gap-x-5'>
          <button
            className='absolute top-1/2 sm:left-[-13%] md:left-[0] transform -translate-y-1/2 px-4 py-2 text-2xl bg-gray-800 text-white rounded-full'
            onClick={prevSlide}
          >
            ❮
          </button>
          <div className='flex flex-1 justify-center items-center'>
            <AnimatePresence mode="wait">
              <motion.img
                key={currentIngredient.img2}
                src={currentIngredient.img2}
                className="lg:feedback2 sm:max-w-[200px] sm:py-10 lg:py-0 md:max-w-[350px] ripple-effect"
                alt={currentIngredient.name}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                loading='lazy'
              />
            </AnimatePresence>
          </div>
          <div className='flex flex-1 flex-col px-5 text-left '>
            <h2 className='font-primary sm:text-4xl md:text-7xl pb-7 '>Nutritional facts <span className='text-accent text-[20px]'><br /> [Per 100g]</span> </h2>
            <h3 className='font-secondary text-2xl pb-5'>{currentIngredient.heading}</h3>
            <p className='pb-5 text-xl'>{currentIngredient.subheading2}</p>
            <ul className='text-md'>
              {currentIngredient.nut_array.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
          <button
            className='absolute top-1/2 sm:right-[-13%] md:right-[0] transform -translate-y-1/2 px-4 py-2 text-2xl bg-gray-800 text-white rounded-full'
            onClick={nextSlide}
          >
            ❯
          </button>
        </div>
      </section>
    </>
  );
}

export default ProductSlider1;